// extracted by mini-css-extract-plugin
module.exports = {"container":"KccmmPrompt_container__3NRpm","title":"KccmmPrompt_title__1w_lp","footer":"KccmmPrompt_footer__3jK6s","yes":"KccmmPrompt_yes__2gxma"};